import { MarkdownViewer } from '../markdownviewer/MarkdownViewer'

type Props = {
  children: string
}

export const ChangelogMarkdownViewer = ({ children }: Props) => (
  <MarkdownViewer
    className="[&_img]:w-lg [&_video]:w-lg [&_video]:min-w-lg text-justify max-w-4xl"
    isTrusted
  >
    {children}
  </MarkdownViewer>
)
